<div>
  <div class="re-spinner-backdrop" [class.re-spinner-fullscreen]="fullscreen"></div>
  <div class="re-spinner-circle" [ngClass]="{'re-spinner-validation': validation}"></div>
</div>
